module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product ba",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bridge Alfa")]), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n             W kwietniu 2016 LSI Fund stało się znaczącym udziałowcem Bioseco. Pieniądze, za które Fundusz objął udziały w 80% pochodziły ze wsparcia NCBIR. Te pieniądze pozwoliły Bioseco rozwinąć stereoskopową technologię wizyjną i zaprojektować pierwsze wersje prototypów urządzenia przeznaczonego dla operatorów farm wiatrowych oraz lotnisk. Urządzenia w wersji MVP zostały potem zaimplementowane u pierwszych branżowych klientów Bioseco. Niewątpliwym sukcesem tego etapu działalności Bioseco był fakt, że po zainstalowaniu urządzeń śmiertelność ptaków pod turbinami spadła do zera.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                W okresie 04.2016-05.2019 Bioseco S.A. realizowała projekt pod tytułem „Bioseco” w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020, Priorytet 1, Działanie 1.3,\nPoddziałanie 1.3.1 – Wsparcie Projektów Badawczo-Rozwojowych w fazie preseed przez fundusze typu Proof of Concept – Bridge Alfa.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Cel projektu:"), _c('br'), _vm._v("\nCelem Projektu było zaprojektowanie, wytworzenie oraz wdrożenie na rynek innowacyjnego urządzenia wspomagającego rozwój inwestycji energetycznych i lotniskowych oraz procesy prowadzenia badań środowiskowych.\n "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Wartosć projektu:"), _c('br'), _vm._v("\n                3 000 000,00PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                2 400 000.00PLN\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               In April 2016, LSI Fund became a significant shareholder in Bioseco. 80% of the money for which the Fund acquired shares came from the NCBIR support. These funds have allowed Bioseco to develop stereoscopic vision technology and to design the first versions of device prototypes for wind farm and airports. The devices in the MVP version were later implemented at the first customers of Bioseco. The undoubted success of this stage of Bioseco's activity was the fact that after installing the devices, the mortality of birds where the system was operating dropped to zero.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                04.2016-05.2019 Bioseco SP. z o.o. realized project called “Bioseco” within the Operational Programme Smart Growth 2014-2020, Priority 1, Measure 1.3.,\nSub- measure 1.3.1 - Support for R&D projects at the ‘pre-seed’ stage by proof of concept funds – Bridge Alfa\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               The aim of the Project was to design, manufacture and implement to the market an innovative tool supporting the development of energy and airport investments and the processes of conducting the environmental assessment.\n                "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                3 000 000,00PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                 Amount of founding from UE:"), _c('br'), _vm._v("\n                2 400 000.00PLN\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a2a0a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BridgeAlfa.vue
// module id = 300
// module chunks = 0